import { __decorate } from "tslib";
import { AsnProp, OctetString } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier } from "@peculiar/asn1-x509";
export class MessageImprint {
    constructor(params = {}) {
        this.hashAlgorithm = new AlgorithmIdentifier();
        this.hashedMessage = new OctetString();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], MessageImprint.prototype, "hashAlgorithm", void 0);
__decorate([
    AsnProp({ type: OctetString })
], MessageImprint.prototype, "hashedMessage", void 0);
